import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer,
} from 'recharts'

function shortLiters(v) {
  if (v >= 1_000) return `${(v / 1_000).toFixed(1)}kL`
  return `${v}L`
}

function shortDate(dateStr) {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-NG', {
    day: 'numeric', month: 'short',
  })
}

const tooltipStyle = {
  borderRadius: 8,
  border: 'none',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
  fontSize: 12,
}

export default function SalesChart({ data }) {
  if (!data.length) return null

  const chartData = data.map((d) => ({ ...d, label: shortDate(d.date) }))

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <p className="text-sm font-semibold text-gray-700 mb-3">Tank vs Pump Sales</p>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={chartData} margin={{ top: 4, right: 4, left: 0, bottom: 0 }} barCategoryGap="30%">
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            tickFormatter={shortLiters}
            tick={{ fontSize: 11, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
            width={48}
          />
          <Tooltip
            formatter={(value, name) => [shortLiters(value), name]}
            contentStyle={tooltipStyle}
          />
          <Legend
            wrapperStyle={{ fontSize: 12 }}
            iconType="circle"
            iconSize={8}
          />
          <Bar dataKey="tankSales" fill="#3b82f6" radius={[4, 4, 0, 0]} name="Tank Sales" />
          <Bar dataKey="pumpSales" fill="#f59e0b" radius={[4, 4, 0, 0]} name="Pump Sales" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
